/* eslint-disable no-unused-vars */
import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase'
import VueScrollTo from 'vue-scrollto'

import Login from '@/pages/Login'
import Dashboard from '@/pages/Dashboard.vue'
import Index from '@/pages/Index'
import Profiles from '@/pages/Profiles'
import Posts from '@/pages/Posts'
import Blog from '@/pages/Blog'
import Sobre from '@/pages/Sobre'
import Terms from '@/pages/Terms'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      VueScrollTo.scrollTo(to.hash, 700)
      return { selector: to.hash }
    } else if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '*',
      redirect: '/dashboard'
    },
    {
      path: '/',
      name: 'Index',
      component: Index,
      meta: {
        title: 'Home - Psyservice'
      }
    },
    {
      path: '/sobre',
      name: 'Sobre',
      component: Sobre,
      meta: {
        title: 'Sobre - Psyservice'
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        title: 'Login - Psyservice'
      }
    },
    {
      path: '/profiles/:id',
      name: 'Profiles',
      component: Profiles,
      meta: {
        title: 'Perfil - Psyservice'
      }
    },
    {
      path: '/posts/:id',
      name: 'Posts',
      component: Posts,
      meta: {
        title: 'Post - Psyservice'
      }
    },
    {
      path: '/blog',
      name: 'Blog',
      component: Blog,
      meta: {
        title: 'Blog - Psyservice'
      }
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true,
        title: 'Dashboard - Psyservice'
      }
    },
    {
      path: '/terms',
      name: 'terms',
      component: Terms,
      meta: {
        requiresAuth: false,
        title: 'Termos de Uso'
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
  const currentUser = firebase.auth().currentUser

  if (requiresAuth && !currentUser) {
    next('/login')
  } else if (requiresAuth && currentUser) {
    next()
  } else {
    next()
  }
})

const DEFAULT_TITLE = 'Psyservice'
router.afterEach((to, from) => {
  document.title = to.meta.title || DEFAULT_TITLE
})

export default router
